import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { animateScroll } from 'react-scroll'

import { GenericAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'

import SuccessImage from 'assets/images/new-success.png'
import {
  trackSubscriptionReopenSuccessButtonTappedPayload,
  trackSubscriptionReopenSuccessScreenViewedPayload,
} from 'generated/trackingEvents'
import { User } from 'generated/types'
import { useTierSubscription } from 'hooks/useTierSubscription'
import { routes } from 'router/routes'
import { reopenFlowTypeInReopenFunnel } from 'utils/analytics/reopenFlowAnalytics'
import { REOPEN } from 'utils/testing/testIDs'

import {
  ButtonContainer,
  Container,
  ReopenMessage,
  ReopenSuccessIcon,
  StyledButton,
  TextContainer,
  Title,
} from './styled-components'

type Props = {
  setStep: (index: number) => void
  user: User
  analytics: GenericAnalyticsClient
  isLongReopen?: boolean
}

export const ReopenSuccess = (props: Props) => {
  const { user, isLongReopen } = props
  const history = useHistory()
  const { getRemoteString } = useRemoteStrings()
  const { subscriptionTierKey, subscriptionTierPrice } = useTierSubscription()
  const ctaTitle = getRemoteString({ key: 'registration.reopen.success.cta' })
  const hasTierData = subscriptionTierKey && subscriptionTierPrice
  const reopenFlowType = reopenFlowTypeInReopenFunnel(isLongReopen)

  useEffect(() => {
    animateScroll.scrollToTop()
  }, [])

  useEffect(() => {
    hasTierData &&
      props.analytics.track(
        ...trackSubscriptionReopenSuccessScreenViewedPayload({
          funnel: 'reopen',
          type: reopenFlowType,
          tierKey: subscriptionTierKey,
          tierPrice: subscriptionTierPrice.toString(),
        }),
      )
  }, [hasTierData])

  const handleOnLink = async () => {
    if (!hasTierData) {
      throw `Tier Data cannot be retrieved for ${user.uuid}`
    }

    props.analytics.track(
      ...trackSubscriptionReopenSuccessButtonTappedPayload({
        funnel: 'reopen',
        type: reopenFlowType,
        ctaTitle: ctaTitle,
        tierKey: subscriptionTierKey,
        tierPrice: subscriptionTierPrice.toString(),
      }),
    )
    history.go(routes.present)
  }

  return (
    <Container>
      <TextContainer className="fully-responsive-padding">
        <ReopenSuccessIcon src={SuccessImage} />
        <Title data-testid={REOPEN.MESSAGE}>
          {getRemoteString({ key: 'registration.reopen.success.title' })}
        </Title>
        <ReopenMessage>
          {getRemoteString({ key: 'registration.reopen.success.message.body' })}
        </ReopenMessage>
      </TextContainer>
      <ButtonContainer>
        <StyledButton
          margin="0 auto 0px"
          onPress={handleOnLink}
          data-testid={REOPEN.CTA}
        >
          {ctaTitle}
        </StyledButton>
      </ButtonContainer>
    </Container>
  )
}
